import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import Spinner from "../../Layouts/Spinner";
import FullScreenLoader from "../../Layouts/FullScreenLoader/FullScreenLoader";
import { getSingleUserTicketById, updateUserOneTicket } from "../../../redux/userTickets/action";

const UserTicketUpdate = () => {
  const { utid } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const singleTicketDetails = useSelector(
    (state) => state?.reusableSlice?.singleUserTicket
  );

  useEffect(() => {
    if (utid) {
      dispatch(getSingleUserTicketById(utid));
    }
  }, [utid]);


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      category_title:
        singleTicketDetails && singleTicketDetails.category_title
          ? singleTicketDetails.category_title
          : "",
      user_name:
        singleTicketDetails && singleTicketDetails.user_name
          ? singleTicketDetails.user_name
          : "",
      message:
        singleTicketDetails && singleTicketDetails.message
          ? singleTicketDetails.message
          : "",
      status:
        singleTicketDetails && singleTicketDetails.status
          ? singleTicketDetails.status
          : "",
    },
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });


  useEffect(()=>{
    singleTicketDetails && formik.setFieldValue("status", singleTicketDetails.status)
  },[singleTicketDetails]) 

  const handleSubmit = async (values) => {
    const data = {
      ...values,
      id: utid,
    };
    dispatch(updateUserOneTicket(data, setLoading));
  };

  const handleChangeStatus = (e) => {
    const gender = e.target.value;
    formik.setFieldValue("status", Number(gender));
  };

  return (
    <div className="px-4 pb-3 pt-5">
      <h3 className="pb-5">Update User Ticket</h3>
      {!singleTicketDetails ? (
        <FullScreenLoader />
      ) : (
        <form onSubmit={formik.handleSubmit}>
          <div className="row ">
            <div className="col-md-3 form-group">
              <label>Category</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter category title"
                name="title"
                disabled
                value={formik.values.category_title}
              />
            </div>

            <div className="col-md-3 form-group">
              <label>User</label>
              <input
                type="text"
                disabled
                className="form-control"
                placeholder="Enter customer name"
                name="user_name"
                value={formik.values.user_name}
              />
            </div>

            <div className="form-group col-md-3">
              <label htmlFor="status">Status</label>
              <select
                id="status"
                title="status"
                className="form-control"
                onChange={handleChangeStatus}
                onBlur={formik.handleBlur}
                value={formik.values.status}
              >
                <option value="">Select Status</option>
                <option value="1">Resolved</option>
                <option value="0">Not Resolved</option>
              </select>
            </div>
            <div className="form-group col-md-4">
              <label htmlFor="status">Messagge</label>
              <div>
                <textarea
                  className="form-group col-md-12"
                  disabled
                  rows={5}
                  value={formik.values.message}
                />
              </div>
            </div>
          </div>
          <div
            className="d-flex align-items-center justify-content-center mt-3  "
            style={{ columnGap: "20px" }}
          >
            <button
              className="submit-btn  "
              onClick={() => {
                navigate("/userticketslist");
              }}
              style={{ width: "max-content" }}
            >
              Back
            </button>
            <button
              className="submit-btn   "
              style={{ width: "max-content" }}
              type="submit"
            >
              {!loading ? "Submit" : <Spinner />}
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default UserTicketUpdate;
